/* istanbul ignore file */
import { DefaultDropdownProps, Dropdown } from 'framework/form';
import { ACTIVE_STATUS, ARCHIVED_STATUS } from 'domain/shared/budget';
import { DropDownFilter } from 'framework/list';

interface BudgetStatusFilterProps extends DefaultDropdownProps {
  value?: string;
}

const BudgetStatusFilter = (props: BudgetStatusFilterProps) => {
  return (
    <DropDownFilter {...props}>
      <Dropdown
        {...props}
        placeholder="Select status"
        options={[
          { value: ACTIVE_STATUS, label: 'Active' },
          { value: ARCHIVED_STATUS, label: 'Archived' },
        ]}
      />
    </DropDownFilter>
  );
};

export default BudgetStatusFilter;
